import { ApiResponse, TokenData, SourceOfBusiness } from '../models';
import * as http from './http';
import ApiService from './service';

export class SourceOfBusinessService extends ApiService {
  public async loadAllSourceOfBusiness() {
    const url = `${this.apiDomain}/api/business-source`;

    const resposne = await http.get<ApiResponse<SourceOfBusiness[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }
  public async createSourceOfBusiness(data: SourceOfBusiness) {
    const url = `${this.apiDomain}/api/business-source`;

    const response = await http.post<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }
  public async updateSourceOfBusiness(data: SourceOfBusiness, id?: string) {
    const url = `${this.apiDomain}/api/business-source/${id}`;

    const response = await http.put<ApiResponse<TokenData>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteSourceOfBusiness(id?: string) {
    const url = `${this.apiDomain}/api/business-source/${id}`;

    const response = await http.remove<ApiResponse<SourceOfBusiness>>(
      url,
      this.store
    );
    return response.data;
  }
}
